<template>
  <base-dialog
    :action="onAction"
    :action-name="'Select'"
    :close="onClose"
    :title="'Select tax rates'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-container>
        <v-row v-if="!isLoading">
          <v-col cols="1" />
          <v-col cols="10">
            <v-select
              v-model="selectedTaxRates"
              multiple
              chips
              outlined
              dense
              label="Tax Rates"
              :items="items"
              item-value="id"
              item-text="formattedName"
            />
          </v-col>
        </v-row>

        <v-row v-if="isLoading">
          <v-col cols="12">
            <v-row
              align="center"
              justify="center"
              style="height: 250px;"
            >
              <v-progress-circular
                :size="100"
                :width="5"
                color="primary"
                indeterminate
              />
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseDialog from "../Common/BaseDialog"

export default {
  components: { BaseDialog },
  props: {
    initSelected: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      isLoading: false,
      selectedTaxRates: this.initSelected,
      taxRates: [],
    }
  },
  computed: {
    ...mapGetters([ 'getTaxRates' ]),
    items() {
      return this.getTaxRates
        .filter(rate => rate.active)
        .map(rate => {
          const incl = rate.inclusive ? ' incl.' : ''
          rate.formattedName = `${rate.display_name} - ${rate.jurisdiction} (${rate.percentage}%${incl})`
          return rate
        })
    }
  },
  watch: {
    initSelected() {
      this.selectedTaxRates = this.initSelected
    }
  },
   created() {
    this.isLoading = true
     this.listTaxRates({})
       .then(res => {
       })
      .finally(() => {
        this.isLoading = false
      })
  },
  methods: {
    ...mapActions([ 'listTaxRates', 'getTaxRate' ]),
    onClose() {
      this.$emit('close')
    },
    async onAction() {
      // All the tax rates should be in state, so these calls should be immediate
      const taxRates = await Promise.all(this.selectedTaxRates.map(taxId => {
        const payload = { id: taxId }
        return this.getTaxRate(payload)
      }))

      this.$emit('action', taxRates)
    }
  }
}
</script>
